import { Component, Inject } from '@angular/core';
import { EVC_MODAL_REF, type ModalRef } from "../_shared/services/modal/evc-modal.service";

@Component({
    selector: 'app-third-party-notice',
    templateUrl: './third-party-notice.component.html',
    styleUrls: ['./third-party-notice.component.scss'],
    standalone: false
})
export class ThirdPartyNoticeComponent {

  constructor(
    @Inject(EVC_MODAL_REF) private modalRef: ModalRef<any>
  ) { }

  close() {
    this.modalRef.close();
  }
}
